module.exports = __webpack_public_path__ + "static/media/3.39fab8bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/3.png
// module id = 812
// module chunks = 0